import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'
// import permission from './modules/permission'
import imDB from './modules/imDB'
import getters from './getters'
import tecentIm from './modules/tecentIm'
Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        app,
        user,
        imDB,
        tecentIm
    },
    state: {
        permission:[],
        userInfo:{
            headImgUrl:'',
            name:'',
        },
    },
    mutations: {
        SET_PERMISSION:(state,info) =>{
            state.permission = info
        },
        SET_USERINFO:(state,info) =>{
            state.userInfo = info
        }
    },
    actions: {
        GetUserInfo({commit}){
            return new Promise((resolve,reject) =>{
                var uid = localStorage.uid;
                if (uid) {
                    Vue.prototype.$get(`user/${uid}/detail`).then(res => {
                        commit('SET_USERINFO', res);
                        resolve(res)
                    })
                }
            },err=>{
                reject(err)
            })
        },
        GetPermission({commit}) {
            return new Promise((resolve, reject) => {
                Vue.prototype.$get("loginAuth").then(res => {
                    var source = res || [];
                    var permission = [];
                    for (let i = 0; i < source.length; i++) {
                        var item = source[i].split(":");
                        if (item[0]) {
                            permission.push(item[0]);
                            var sub = item[1];
                            if (sub) {
                                permission.push(item[0] + ":" + sub);
                            }
                        }
                        permission.push(source[i])
                    }
                    permission = Array.from(new Set(permission));
                    localStorage.permission = JSON.stringify(permission);
                    commit('SET_PERMISSION', permission);
                    resolve(permission)
                }, err => {
                    Vue.prototype.$message.error("用户权限获取失败")
                    reject();
                });
            })
        },
    },
    getters
})
